import React from 'react'
import { PRIORITY_STYLES } from './constants'
import styles from './ProtocolInfographic.module.css'

const BADGE_CLASSES = {
  critical: styles.badgeCritical,
  high: styles.badgeHigh,
  medium: styles.badgeMedium,
  low: styles.badgeLow
}

const SignalIcon = ({ level }) => {
  const bars = [
    { h: 5, active: level >= 1 },
    { h: 9, active: level >= 2 },
    { h: 13, active: level >= 3 },
    { h: 17, active: level >= 4 }
  ]

  return (
    <span style={{ display: 'inline-flex', alignItems: 'flex-end', gap: '4px', height: '17px', marginRight: '6px' }}>
      {bars.map((bar, i) => (
        <span
          key={i}
          style={{
            width: '4px',
            height: `${bar.h}px`,
            borderRadius: '2px',
            backgroundColor: bar.active ? 'currentColor' : 'rgba(0,0,0,0.06)',
            transition: 'background-color 0.2s ease'
          }}
        />
      ))}
    </span>
  )
}

export default function PriorityBadge({ priority }) {
  if (!priority) {
    return null
  }

  const s = PRIORITY_STYLES[priority]
  const className = `${styles.badge} ${BADGE_CLASSES[priority] || ''}`
  
  const signalLevel = {
    critical: 4,
    high: 3,
    medium: 2,
    low: 1
  }[priority] || 1

  return (
    <span className={className}>
      <SignalIcon level={signalLevel} />
      {(s && s.label) || priority}
    </span>
  )
}
